export const SET_SINGLE_SHIFT_DATA = "SET_SINGLE_SHIFT_DATA";
export const SET_SHIFT_DATA = "SET_SHIFT_DATA";
export const RESET_SHIFT_REDUCER = "RESET_SHIFT_REDUCER";
export const SET_SHIFT_PAGINATION = "SET_SHIFT_PAGINATION";
export const SET_SINGLE_SHIFT_RIDER_DATA = "SET_SINGLE_SHIFT_RIDER_DATA";
export const SET_SINGLE_SHIFT_RIDER_PAGINATION = "SET_SINGLE_SHIFT_RIDER_PAGINATION";
export const SET_SHIFT_TYPES = "SET_SHIFT_TYPES";
